import { Component, OnInit } from '@angular/core';
import {
  trigger,
  transition,
  style,
  animate,
  query,
  stagger,
} from '@angular/animations';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SearchService } from '../../search/search/search.service';
import { ServicePoTokenAuthService } from 'src/app/shared/services/service-po-token-auth.service';

@Component({
  selector: 'app-service-po-token-login',
  templateUrl: './servicePoTokenLogin.component.html',
  styleUrls: ['./servicePoTokenLogin.component.css'],
  animations: [
    trigger('pageFadeUp', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(100vh)' }),
        animate(
          '1200ms cubic-bezier(.22,1,.36,1)',
          style({ opacity: 1, transform: 'translateY(0)' })
        ),
      ]),
    ]),
    trigger('staggerFadeUp', [
      transition(':enter', [
        query(
          '.stagger-item',
          [
            style({ opacity: 0, transform: 'translateY(13px)' }),
            stagger(80, [
              animate(
                '350ms ease-out',
                style({ opacity: 1, transform: 'translateY(0)' })
              ),
            ]),
          ],
          { optional: true }
        ),
      ]),
    ]),
  ],
})
export class ServicePoTokenLoginComponent implements OnInit {
  securityToken = '';
  loading = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private snackBar: MatSnackBar,
    private searchService: SearchService,
    private servicePoTokenAuth: ServicePoTokenAuthService
  ) {}

  ngOnInit() {}

  async verifyToken() {
    const raw = (this.securityToken || '').trim();
    if (!raw) {
      this.snackBar.open('Please enter a valid Security Token', 'Close', {
        duration: 3000,
      });
      return;
    }

    this.loading = true;
    try {
      const data: any = await this.searchService.verifyServicePoToken(raw);
      if (data?.valid) {
        if (data?.servicePoAccessToken && data?.servicePurchaseOrderId) {
          this.servicePoTokenAuth.set(data.servicePoAccessToken, data.servicePurchaseOrderId, data?.supplierId, data?.companyId);
        }
        this.snackBar.open('Token verified successfully', 'Close', {
          duration: 3000,
        });
        if (data?.servicePurchaseOrderId) {
          this.router.navigate(['/servicePoToken/po-details'], {
            queryParams: { servicePurchaseOrderId: data.servicePurchaseOrderId },
          });
        }
      } else {
        const reason = data?.reason;
        let msg = 'Invalid token. Please check and try again.';
        if (reason === 'expired') msg = 'Token has expired. Please request a new one from the buyer.';
        else if (reason === 'server_config_error') msg = 'Server configuration error. Please contact support.';
        this.snackBar.open(msg, 'Close', {
          duration: 3500,
        });
      }
    } catch (err) {
      this.snackBar.open('Verification failed. Please try again.', 'Close', {
        duration: 3500,
      });
    } finally {
      this.loading = false;
    }
  }
}
